import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = (global) =>
  makeStyles(() =>
    createStyles({
      pageLoaderPro: {
        position: global ? 'fixed' : 'absolute',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%',
        'z-index': global ? '9999' : 1000,
        textAlign: 'center',
        color: '#ffffff',
        background: global ? '#1B1925' : 'transparent',
      },
      centerLoader: {
        display: 'inline-block',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
      },
      customLoader: {
        width: '100px',
        height: '100px',
        display: 'inline-block',
        position: 'relative',
      },
      customLoaderImg: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 'auto',
        outline: '1px solid transparent',
        '&.fuLogo2': {
          animationName: 'fu-rotate',
          animationDuration: '2s',
          animationIterationCount: 'infinite',
          animationTimingFunction: 'linear',
        },
        '&.fuLogo3': {
          animationName: 'fu-rotate-backwards',
          animationDuration: '2s',
          animationIterationCount: 'infinite',
          animationTimingFunction: 'linear',
        },
      },
    }),
  );
export default useStyles;
